import { Button, MenuItem, TextField } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";
import { BsX } from "react-icons/bs";

const index = (props: { register: any; handleSubmit: any; errors: any; formValue: any; setFormValue: any; handleNext: any; append: any; remove: any; unRegister: any; fields: any }) => {
  const onError = (data: any) => {
    toast.error(data[Object.keys(data)[0]].message, {
      theme: "colored",
    });
  };

  const onSubmit = (data: any) => {
    props.setFormValue({
      ...props.formValue,
      addresses: data.addresses,
    });

    props.handleNext();
  };

  const remove = (index: number) => {
    props.unRegister(`addresses.${index}`);
    props.remove(index);
  };
  
  return <>
    <form id="page2" onSubmit={props.handleSubmit(onSubmit, onError)}>
      {props.fields.map((address: any, index: number) => (
        <div key={address.id}
          className="relative container drop-shadow-md rounded-lg my-2 py-5 px-10 grid grid-cols-1 gap-2 border-2 bordre-gray-200 sm:py-0 sm:pl-0"
        >
          <div className="grid grid-cols-1 gap-2 m-2">
            <TextField size="small" select label="Address Type" {...props.register(`addresses.${index}.addressType`)} defaultValue={props.formValue?.addresses?.[index]?.addressType}>
              <MenuItem value="Resedence">Resedence</MenuItem>
            </TextField>
            <TextField size="small" label="Value" {...props.register(`addresses.${index}.value`)} />
          </div>
          <span
            className="absolute top-0 right-0 hover:cursor-pointer"
            onClick={() => remove(index)}
          >
            <BsX size="1.5rem" />
          </span>
        </div>
      ))}
    </form>
    <Button onClick={() => props.append()}>Add Address</Button>
  </>;
};

export default index;
